import { Grid } from '@mui/material';
import { ChartBox, SlideParagraph, SlideTitle } from 'features/slides';
import { PortfolioStatisticsLineChart } from 'pages/Cases/components/PortfolioStatisticsLineChart';
import { SummaryStatisticsScatterChart } from 'pages/Cases/components/SummaryStatisticsScatterChart';
import { portfolioStatisticsChartFilter } from 'pages/Cases/PortfolioConstruction/Summary/PerformanceReport';
import React from 'react';

export type ScatterPlotsProps = {
  readonly filteredPerformance: any;
};

export function ScatterPlots({
  filteredPerformance,
}: ScatterPlotsProps): React.ReactElement {
  return (
    <Grid
      container
      flexDirection="column"
      gap={0}
      sx={{
        width: '100%',
        padding: '10px',
      }}
    >
      <Grid
        container
        sx={{
          marginBottom: '6px',
        }}
      >
        <SlideTitle>Return and Risk Statistics</SlideTitle>
      </Grid>

      <Grid
        item
        container
        justifyContent="space-between"
        direction="row"
        gap={2}
      >
        <Grid item sx={{ width: 'calc(50% - 8px)' }}>
          <ChartBox>
            <SummaryStatisticsScatterChart
              data={portfolioStatisticsChartFilter({
                filteredPerformance,
                name: 'performance_stats',
              })}
              xValue="standard_deviation"
              yValue="cagr"
              name="Return / Standard Deviation"
              formatChart={{
                label: 'Return (%)',
              }}
              height={250}
              isWithAnimation={false}
              showLegend={false}
            />
          </ChartBox>
        </Grid>
        <Grid item sx={{ width: 'calc(50% - 8px)' }}>
          <ChartBox>
            <SummaryStatisticsScatterChart
              data={portfolioStatisticsChartFilter({
                filteredPerformance,
                name: 'performance_stats',
              })}
              xValue="max_drawdown"
              yValue="cagr"
              name="Return / Maximum Drawdown"
              formatChart={{
                label: 'Return (%)',
              }}
              height={250}
              isWithAnimation={false}
              showLegend={false}
            />
          </ChartBox>
        </Grid>
      </Grid>
      <ChartBox>
        <PortfolioStatisticsLineChart
          data={portfolioStatisticsChartFilter({
            filteredPerformance,
            name: 'drawdown_series',
          })}
          formatChart={{
            unit: '%',
            decimals: 2,
            prefix: '',
            value: 'Maximum Drawdown',
            label: 'Maximum Drawdown (%)',
          }}
          name="Maximum Drawdown"
          height={250}
          isWithAnimation={false}
          showShape={true}
        />
      </ChartBox>
      <SlideParagraph
        style={{
          marginBottom: '10px',
          marginTop: '10px',
          fontSize: '13px',
        }}
      >
        Source: TIFIN Sage
      </SlideParagraph>
    </Grid>
  );
}
